import {
    useEnableDeviceConfirmation,
    useGetDeviceConfirmation,
} from 'api/device';
import {SettingsTabs} from 'components/pages/SettingsPage/useSettingsPage';
import {PATH} from 'constants/common';
import {useAuth} from 'context/auth-context';
import {useLanguage} from 'context/language-context';
import {useNotification} from 'context/notification-context';
import {useHistory, useParams} from 'react-router';

const useDeviceWhitelistingPublicPage = () => {
    const {user} = useAuth();
    const history = useHistory();
    const {hash, uuid} = useParams<{hash: string; uuid: string}>();
    const {data, isLoading, error} = useGetDeviceConfirmation({hash, uuid});
    const {mutate: enableDevice, isPending} = useEnableDeviceConfirmation();
    const {addNotification} = useNotification();
    const {selectedLanguageParams} = useLanguage();

    const handleEnableDevice = () => {
        enableDevice(
            {hash, uuid},
            {
                onSuccess: () => history.push(PATH.LOGIN),
                onError: (err: any) => {
                    addNotification(
                        {
                            area: 'device-confirmation',
                            message:
                                err?.['hydra:description'] ||
                                'Something went wrong',
                            status: 'error',
                        },
                        'device-confirmation',
                    );
                },
            },
        );
    };

    const handleDeny = () => {
        const changePasswordPath = `${PATH.SETTINGS}?tab=${SettingsTabs.CHANGEPW}`;
        if (!!user) {
            history.push(changePasswordPath);
        } else {
            history.push({
                pathname: PATH.LOGIN,
                search: `afterLoginRedirect=${window.btoa(changePasswordPath)}`,
            });
        }
    };

    const handleError = () => {
        history.push(PATH.DASHBOARD);
    };

    return {
        data,
        isLoading,
        error,
        handleEnableDevice,
        isPending,
        handleDeny,
        selectedLanguageParams,
        handleError,
    };
};

export default useDeviceWhitelistingPublicPage;
